
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs/Rx';
import { Teacher } from '../models/teacher.model';
import { GlobalState } from '../global.state';
@Injectable()
export class TeacherService {
  constructor(
    private apiService: ApiService,
    private _state: GlobalState,
  ) { }
  getAll(): Observable<Teacher[]> {
    return this.apiService.get('reg/teachers').pipe(map((result) => result.data));
  }
  addTeacher(datas): Observable<any>{
    return this.apiService.post('reg/teachers', datas);
  }
  updateTeacherInfo(id, data): Observable<any>{
    this.resetInfo();
    return this.apiService.put('reg/teachers/'+id, data);
  }
  deleteTeacher(id): Observable<any>{
    return this.apiService.delete('reg/teachers/'+id);
  }
  resetInfo(){
    this.apiService.get('user/info')
      .subscribe((data) => {
        this._state.notifyDataChanged('[User] UPDATE', data.data);
      });
  }
  update(user){
    return this.apiService.put(`reg/teachers/${user.id}`,user).map((result) => result.data);
  }

  noti() {
    return this.apiService.get('noti').pipe(map((result) => result.data));
  }
}
